export const environment = {
  production: false,
  //API_ENDPOINT: 'http://54.71.18.74:3543/',  //local sever url
  //WEB_ENDPOINT: 'http://54.71.18.74:3543/',   //local website url
  API_ENDPOINT: 'https://vehicletracking.thedevlogix.com/',  //local sever url
  WEB_ENDPOINT: 'https://vehicletracking.thedevlogix.com//portal/',  //local website url
  S3_URL: 'https://routexlogisticsdevdata.s3.eu-central-1.amazonaws.com/',
  AWS_accessKeyId: 'AKfgdgdFDXAZQU',
  AWS_secretAccessKey: 'vdhdhdhdWp',
  AWS_region: 'eu-central-1',
  AWS_bucketname : 'routexlogisticsdevdata'
};